var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalOcean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 32.017v-6.205c6.568 0 11.666-6.513 9.144-13.425a9.272 9.272 0 00-5.533-5.534C12.7 4.35 6.187 9.429 6.187 15.997H0C0 5.529 10.124-2.635 21.1.793 25.89 2.3 29.716 6.11 31.204 10.9c3.43 10.993-4.717 21.117-15.204 21.117z",
    fill: "#0080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.851 25.83h6.168v-6.168H9.852v6.168zm-4.753 4.753h4.753v-4.752H5.098v4.752zm-3.973-4.752h3.973v-3.975H1.125v3.975z",
    fill: "#0080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalOcean);
export default __webpack_public_path__ + "static/media/digitalOcean.8c81d8497ed0b3c8145389ef627140d8.svg";
export { ForwardRef as ReactComponent };